import styled from 'styled-components';

import TextField from '../../../../../../../../components/v2/TextField';

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  margin-left: auto;
`;

const StyledRepeatCountInput = styled(TextField)`
  width: 180px;
  margin-bottom: 0;
`;

export {
  ActionButtonsContainer,
  StyledRepeatCountInput,
};
